module.exports = __webpack_public_path__ + "static/media/mobilePhones.1db6148c.png";